import axios from 'axios';
import { baseURL, api_key } from './config';
import { message } from 'antd';

const instance = axios.create({
  baseURL,
  timeout: 50000,
});

instance.defaults.headers.common['X-Api-Key'] = api_key;

const makeRequest = async config => {
  try {
    const response = await instance.request(config);
    if (response.data.status !== 200) {
      message.error(response.data.error);
    } else {
      return response.data;
    }
  } catch (error) {
    throw new Error(error.response.data);
  }
};

const sendRequest = async (
  method,
  url,
  data = null,
  params = null,
  headers
) => {
  const config = {
    method,
    url,
    data,
    params,
    headers,
  };
  return makeRequest(config);
};

export { sendRequest };
